import Repository from "./Repository";

export default {
    launchSurvey(line_item_id) {
        return Repository.post(`/survey/${line_item_id}/launch`, {id: line_item_id});
    },
    stopSurvey(line_item_id) {
        return Repository.post(`/survey/${line_item_id}/stop`);
    },
    updateSurvey(line_item_id, survey) {
        return Repository.post(`/survey/${line_item_id}/update`, survey);
    },
    createSurvey(survey) {
        return Repository.post("/survey/create", survey);
    },
};
